import {Grid, Stack, Typography} from '@mui/material'
import FormTextField from 'src/components/ui/TextField'
import AutoComplete, {AutocompleteOption} from 'src/components/ui/AutoComplete'
import {useFormContext} from 'react-hook-form'

interface InstitutionDetailsProps {
  cities: any[]
}

const InstitutionDetails = ({cities}: InstitutionDetailsProps) => {
  const {setValue} = useFormContext()

  const onChangeCityName = (newValue: AutocompleteOption | null) => {
    setValue('city', newValue?.label)
  }

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6">פרטי מוסד:</Typography>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <FormTextField name="name" label="שם המוסד" />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="phone" label="טל' מוסד" />
        </Grid>
        <Grid item xs={3}>
          <FormTextField
            name="institutionHeadName"
            label="שם ראש כולל/ראש ישיבה"
          />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="institutionHeadPhone" label="טל' ראש מוסד" />
        </Grid>
        <Grid item xs={5}>
          <FormTextField name="street" label="רחוב" />
        </Grid>
        <Grid item xs={1}>
          <FormTextField name="houseNumber" label="מס’ בית" />
        </Grid>
        <Grid item xs={3}>
          <AutoComplete
            options={cities}
            name="city"
            label={'עיר'}
            onChange={onChangeCityName}
            getValue={o => o?.label}
          />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="zipCode" label="מיקוד" />
        </Grid>
      </Grid>
    </Stack>
  )
}

export default InstitutionDetails
